import {composeReducers} from 'common/util/composeReducers';
import { ACTIONS } from 'part11/actions/signingStatements';

export function storeSigningStatements(state, action ) {
    if (!action || action.type !== ACTIONS.PART11_SIGNING_STATEMENTS) {
        return state;
    }
    const signingStatements = action.payload;
    return {
        ...state,
        signingStatements
    };
}

export default composeReducers(storeSigningStatements);
